import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Expand from 'components/svgs/icons/expand';

import HubModel from 'models/hub';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
};

export class HubDescription extends Component {
  constructor(props) {
    super(props);

    this.toggleDisplay = this.toggleDisplay.bind(this);

    this.state = {
      expandable: false,
      expanded: false,
    };
  }

  componentDidMount() {
    this.setExpandable();
  }

  setExpandable() {
    if (this.descriptionWrapper) {
      this.setState({
        expandable: this.descriptionWrapper.clientHeight > 200,
      });
    }
  }

  toggleDisplay(e) {
    e.preventDefault();
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  renderExpandLink() {
    if (!this.state || !this.state.expandable) { return null; }

    const { hub } = this.props;
    const { expanded } = this.state;

    let text;
    if (expanded) {
      text = `LESS INFO ABOUT ${hub.name.toUpperCase()}`;
    } else if (this.state) {
      text = `MORE INFO ABOUT ${hub.name.toUpperCase()}`;
    }

    const expandClass = cx({ 'upside-down': expanded });
    return (
      <div className="text-align-center padding-top-10">
        <a href="#" onClick={this.toggleDisplay}>
          {text}
        &nbsp;
          <Expand className={expandClass} />
        </a>
      </div>
    );
  }

  render() {
    const { hub } = this.props;
    if (!hub.description) { return null; }
    const destinationClasses = cx({
      'description-wrapper': true,
      'expandable': this.state.expandable,
      'expanded': this.state.expanded,
    });

    return (
      <div className="padding-top-30 container bottom-shadow-blur">
        <div className="row margin-0 flair-center-infinity-dashes">
          <div className="col-sm-8 col-sm-offset-2 col-xs-12 padding-xs-10">
            <div className="text-weight-bold text-size-20 text-color-dark-slate text-align-center padding-bottom-sm-20 padding-bottom-xs-10">
              ABOUT {hub.name.toUpperCase()}
            </div>
            <div className={destinationClasses} ref={(descriptionWrapper) => { this.descriptionWrapper = descriptionWrapper; }}>
              <ReactMarkdown
                source={hub.description}
                className="text-weight-book text-color-slate text-size-xs-12 margin-top-10 vertical-align-left"
              />
            </div>
            {this.renderExpandLink()}
          </div>
        </div>
      </div>
    );
  }
}

HubDescription.propTypes = propTypes;

export default HubDescription;
